module.exports = __webpack_public_path__ + "static/media/stripe~e7bf7d8afb1b37b6ff9601affd9504a6d6592e36.bfe43fc7.svg";